// src/services/authService.js
import api from './api';

/*
 * NOTE: No need to pass tokens manually here anymore.
 * The axios interceptor in api.js automatically attaches
 * the Bearer token from localStorage to every request.
 */
const authService = {
  checkUsername: async (username) => {
    const { data } = await api.get(`/auth/check-username?username=${encodeURIComponent(username)}`);
    return data;
  },

  sendOTP: async (email, fullName) => {
    const { data } = await api.post('/auth/send-otp', { email, fullName });
    return data;
  },

  register: async ({ fullName, username, email, password, otp }) => {
    const { data } = await api.post('/auth/register', { fullName, username, email, password, otp });
    return data;
  },

  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    return data;
  },

  // Sends OAuth2 access_token (from useGoogleLogin) as "credential"
  googleAuth: async (accessToken) => {
    const { data } = await api.post('/auth/google', { credential: accessToken });
    return data;
    // data.isNewUser === true  → show setup modal
    // data.isNewUser === false → normal login
  },

  // ★ Called from GoogleSetupModal — token auto-attached by interceptor
  completeGoogleSetup: async ({ username, password }) => {
    const { data } = await api.post('/auth/google/complete-setup', { username, password });
    return data;
  },

  getMe: async () => {
    const { data } = await api.get('/auth/me');
    return data;
  },

  updateProfile: async (updateData) => {
    const { data } = await api.put('/auth/profile', updateData);
    return data;
  },

  // ── Forgot Password ─────────────────────────────────────
  // Step 1: request OTP by email
  forgotPassword: async (email) => {
    const { data } = await api.post('/auth/forgot-password', { email });
    return data;
  },

  // Step 2: verify the 6-digit OTP
  verifyForgotPasswordOTP: async (email, otp) => {
    const { data } = await api.post('/auth/verify-forgot-password-otp', { email, otp });
    return data;
  },

  // Step 3: submit new password (OTP re-verified server-side)
  resetPassword: async (email, otp, newPassword) => {
    const { data } = await api.post('/auth/reset-password', { email, otp, newPassword });
    return data;
  },
};

export default authService;